<template>
  <div>
    <v-select
      v-model="model.data"
      :options="options"
      class="w-100"
      taggable
      :multiple="shouldUseMultiple"
      append-to-body
      :create-option="(text) => ({ label: text, value: text })"
      :calculate-position="withPopper"
    >
      <template v-if="!isMultiple" #option="option">
        <div class="d-flex justify-content-between align-items-center w-100">
          <span>{{ option.label }}</span>
          <button
            type="button"
            class="btn btn-sm btn-link text-danger p-0"
            @click.stop="removeOption(option)"
            style="line-height: 1;"
          >
            ×
          </button>
        </div>
      </template>
    </v-select>
  </div>
</template>

<script>
import vSelect from "vue-select";
import popperHelper from "@/libs/popper-helper";

const TYPE = "select";
const MODEL = {
  data: [],
};

export default {
  props: {
    data: Object,
    config: Object,
  },
  components: {
    vSelect,
  },
  computed: {
    isMultiple() {
      return this.config.type === 'multiple_select';
    },
    shouldUseMultiple() {
      return true;
    },
    options() {
      if (!this.model || !this.model.data) {
        return [];
      }
      if (Array.isArray(this.model.data)) {
        return this.model.data;
      }
      return [];
    }
  },
  methods: {
    removeOption(option) {
      if (!Array.isArray(this.model.data)) return;
      const valueKey = typeof option === 'object' && option !== null 
        ? String(option.value || JSON.stringify(option))
        : String(option);
      
      const filtered = this.model.data.filter(item => {
        const itemValue = typeof item === 'object' && item !== null ? item.value : item;
        return String(itemValue) !== valueKey;
      });
      
      this.$set(this.model, 'data', filtered);
    }
  },
  data() {
    return {
      model: MODEL,
    };
  },
  created() {
    const isDataEmpty = JSON.stringify(this.data.data) === "{}";
    this.model = this.data;

    if (isDataEmpty || (TYPE !== this.config.type && this.config.type !== 'multiple_select')) {
      this.model.data = [];
    } else {
      this.model.data = this.data.data;
    }
  },
  watch: {
    model: {
      handler(val) {
        this.$emit("update:data", val);
      },
      deep: true,
    },
  },
  setup() {
    return {
      withPopper: popperHelper.withPopper,
    };
  },
};
</script>

<style></style>
